define([
    "../../hereMapsModule",
    "text!./tripPanel.html",
], function (hereMapsModule, tripPanelView) {
    "use strict";

    return hereMapsModule.directive("tripPanel", [function () {
        return {
            restrict: "E",
            template: tripPanelView,
            scope: {
                routes: "=",
                routesHere: "=",
                onRegisterRoutesHereApi: "="
            },
            controller: ["$scope", "$compile", "hereMapsService", "routeStopModalService",
                function ($scope, $compile, hereMapsService, routeStopModalService) {

                function filterRoutePolyline(id) {
                    return $scope.routesHere.filter(function (routesHere) {
                        return routesHere.data.presentationNode.id === id;
                    });
                }

                $scope.toggleRoute = function (route) {
                    var routesPolyline = filterRoutePolyline(route.presentationNode.id);
                    if (routesPolyline && routesPolyline.length > 0) {
                        routesPolyline.forEach(function (routePolyline) {
                            $scope.onRegisterRoutesHereApi.toggleRoute(routePolyline, route.selected);
                        });
                    }
                };

                function findRoutePolyline(id) {
                    return $scope.routesHere.find(function (routesHere) {
                        return routesHere.data.presentationNode.id === id;
                    });
                }

                $scope.focusOnRoute = function (route) {
                    var routePolyline = findRoutePolyline(route.presentationNode.id);
                    if (routePolyline) {
                        routeStopModalService.clearBubble();
                        $scope.onRegisterRoutesHereApi.focusOnRoute(routePolyline);
                    }
                };

                $scope.focusOnStopAndOpenModal = function (stop) {
                    var coordinate = {
                        lat: stop.geographicInfo.latitude,
                        lng: stop.geographicInfo.longitude
                    };
                    routeStopModalService.openBubble(coordinate, stop.data);
                    $scope.onRegisterRoutesHereApi.focusOnStopByCoordinate(coordinate);
                };

                $scope.showStopInfo = function (route) {
                    var isCurrentlyOpen = route.showStopInfo;

                    $scope.routes.forEach(function(route) {
                        route.showStopInfo = false;
                    });

                    route.showStopInfo = !isCurrentlyOpen;
                };

            }]
        };
    }]);
});